export default "__VITE_ASSET__DBJNlOvk__"